export const PROCESSING_JOB_STATUS_VALUES = [
  'uploaded',
  'processing',
  'pendingReview',
  'reviewed',
  'processed',
  'error',
] as const;

export type ProcessingJobStatus = typeof PROCESSING_JOB_STATUS_VALUES[number];

export type PostProcessorType =
  | 'removeSpacesAndDashes'
  | 'castToNumber'
  | 'extractNumber'
  | 'formatTime'
  | 'normalizeSampleType';
